import type { MouseEvent } from "react";

import { WebsiteTooltip } from "app/components/React/Tooltip/WebsiteTooltip/WebsiteTooltip";
import { getFaviconUrl } from "app/services/sitesService/sitesUtils";
import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";

interface IWebsiteTooltipCellOptions {
    onDomainClick: (domain: string) => void;
    dataAutomation: string;
}

export const renderWebsiteTooltipCell = (domain: string, options?: IWebsiteTooltipCellOptions) => (
    <CoreWebsiteCell
        domain={domain}
        icon={getFaviconUrl(domain)}
        hideTrackButton
        textAndIconMargin="8px"
        {...(options
            ? {
                  internalLinkDataAutomationAttribute: options.dataAutomation,
                  trackInternalLink: (event: MouseEvent<HTMLAnchorElement>) => {
                      event.preventDefault();
                      options.onDomainClick(domain);
                  },
              }
            : {})}
        TooltipComponent={({ children }) => (
            <WebsiteTooltip
                domain={domain}
                placement="bottom-left"
                debounce={500}
                hideTrackButton
            >
                {children}
            </WebsiteTooltip>
        )}
    />
);
